import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const SIZES = {
    logoHeight: 22,
    logoWidth: 40,
};

export const LineBreak = styled.div`
    background: ${({ theme }) => theme.Surface.border};
    display: inline-block;
    height: 24px;
    min-width: 1px;
    width: 1px;
`;

export const NetworkContainer = styled.div<{ $isVerticallyAligned?: boolean; $canWrap?: boolean }>`
    ${BaseStyle.Mixins.gaps.small}

    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: initial;
    padding-top: 0;
    padding-bottom: 0;
    flex-flow: ${({ $canWrap }) => ($canWrap ? 'wrap' : 'initial')};

    ${({ $isVerticallyAligned }) =>
        $isVerticallyAligned &&
        css`
            // styles when broadcasts are vertically aligned
            flex-direction: column;
            justify-content: center;
            padding-top: 8px;
            padding-bottom: 8px;
        `}

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.gaps.tiny}
    }
`;

export const NetworkLogos = styled.div<{
    $hasLocalNetworks: boolean;
    $isVerticallyAligned?: boolean;
    $isGamecenter?: boolean;
}>`
    ${BaseStyle.Mixins.gaps.small}

    display: flex;
    align-items: center;

    ${LineBreak}:last-child {
        display: ${({ $hasLocalNetworks, $isVerticallyAligned }) =>
            $hasLocalNetworks && !$isVerticallyAligned ? 'initial' : 'none'};

        ${BaseStyle.Mixins.screenSizes.small} {
            ${({ $isGamecenter }) =>
                $isGamecenter &&
                css`
                    display: none;
                `}
        }
    }
`;

export const NetworkLogo = styled.img<{ $hasBigLogos?: boolean }>`
    max-height: ${SIZES.logoHeight}px;
    max-width: ${SIZES.logoWidth}px;
    height: ${SIZES.logoHeight}px;
`;

export const NetworkNames = styled.div`
    color: ${({ theme }) => theme.Text.secondary};
    text-align: left;

    ${BaseStyle.Mixins.screenSizes.large} {
        display: inline-block;
    }
`;

export const Spacer = styled.div`
    display: none;

    ${BaseStyle.Mixins.screenSizes.small} {
        display: inline;
        width: 100%;
        height: 0;
    }
`;
